export const screenSizes = {sm: 550, md: 600, lg: 1000};

export const breakpoints = (
	Object.keys(screenSizes).reduce((acc, key) => ({ 
		...acc, [key]: `@media (max-width: ${screenSizes[key]}px)` 
	}),{})
)